/**
 * Shared color tokens for the chain-aware clinical report UI.
 * Mirror the design tokens declared in :root inside index.css so that
 * inline-styled components stay consistent with the rest of the page.
 */

export interface SeverityToken {
  bg: string;
  tc: string;
  abbr: string;
}

export interface ImprovementToken {
  bg: string;
  tc: string;
}

export const SEV_COLORS: Record<string, SeverityToken> = {
  Severe:   { bg: '#991B1B', tc: '#FFFFFF', abbr: 'S' },
  Moderate: { bg: '#FEF0E7', tc: '#9A3412', abbr: 'M' },
  Mild:     { bg: '#FEF9C3', tc: '#713F12', abbr: 'Mi' },
  Trace:    { bg: '#D1FAE5', tc: '#065F46', abbr: 'Tr' },
  None:     { bg: '#14532D', tc: '#FFFFFF', abbr: 'N' },
};

export const IMP_COLORS: Record<string, ImprovementToken> = {
  'Getting worse':   { bg: '#FDE8E8', tc: '#9B1C1C' },
  'No change':       { bg: '#FEF9C3', tc: '#713F12' },
  'A little better': { bg: '#D1FAE5', tc: '#065F46' },
  'Much better':     { bg: '#BBF7D0', tc: '#14532D' },
  'Resolved':        { bg: '#86EFAC', tc: '#052E16' },
  'Unknown':         { bg: '#F3F4F6', tc: '#6B7280' },
};

/** 0..10 — keep low values green, ramp through amber to red. */
export const LOC_COLORS: string[] = [
  '#276749',
  '#276749',
  '#2C9A6E',
  '#38B27A',
  '#F6AD55',
  '#ED8936',
  '#E53E3E',
  '#E53E3E',
  '#C53030',
  '#C53030',
  '#9B2C2C',
];

/** Safely resolve a Level-of-Concern color, clamping out-of-range values. */
export const locColor = (level: number | undefined | null): string => {
  if (typeof level !== 'number' || Number.isNaN(level)) return LOC_COLORS[5];
  const idx = Math.max(0, Math.min(LOC_COLORS.length - 1, Math.round(level)));
  return LOC_COLORS[idx];
};
